import { render, staticRenderFns } from "./editform.vue?vue&type=template&id=3411c51a&lang=pug&"
import script from "./editform.vue?vue&type=script&lang=js&"
export * from "./editform.vue?vue&type=script&lang=js&"
import style0 from "./editform.vue?vue&type=style&index=0&id=3411c51a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports